import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['container']

    connect() {
        super.connect()
    }

    disconnect() {
        this.close()
    }

    open(event) {
        event.target.blur()
        this.containerTarget.classList.remove('hidden')
    }

    close() {
        this.containerTarget.classList.add('hidden')
    }

    closeBackground(e) {
        if (e.target === this.containerTarget) {
            this.close(e)
        }
    }
}